import * as React from 'react';
import { Text } from '@grandvisionhq/elements';

const SubscriptionExplainer = ({ information  })=>/*#__PURE__*/ React.createElement(Text, {
        className: "cart-totals__subscription-explainer"
    }, information)
;

export { SubscriptionExplainer };
//# sourceMappingURL=SubscriptionExplainer.js.map
